import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Location } from '@angular/common';
import { BasePage2 } from 'src/app/tools/abstract-classes/base-page2';
import { BaseService } from 'src/app/assabil-kernel/services/base-service';
import { TicketService } from '../../services/ticket-service';
import { Ticket } from '../../models/entities/ticket';
import { TicketCategory } from '../../models/entities/ticket-category-entity';
import { TicketType } from '../../models/entities/ticket-type-entity';
import { LeanUtilsService } from 'src/app/tools/services/lean-utils-service';
import { UserService } from 'src/app/assabil-kernel/services/user-service';
import { TicketTypeLovComponent } from '../ticket-type-lov/ticket-type-lov.component';
import { TicketBatch } from '../../models/entities/ticket-batch';
import { Partner } from 'src/app/assabil-kernel/models/entities/master-data/partner-entity';
import { Itinerary } from 'src/app/assabil-kernel/models/entities/master-data/itinerary-entity';
import { AssetProductCategory } from 'src/app/assabil-kernel/models/entities/control-tables/asset-product-category-entity';
import { BranchLovComponent } from 'src/app/assabil-admin/components/control-tables/branch/branch-lov/branch-lov.component';
import { Branch } from 'src/app/assabil-kernel/models/entities/control-tables/branch-entity';
import { PartnerLovComponent } from 'src/app/assabil-admin/components/master-data/partner/partner-lov/partner-lov.component';
import { AssetProductCategoryLovComponent } from '../asset-product-category-lov/asset-product-category-lov.component';
import { ItineraryLovComponent } from 'src/app/assabil-admin/components/master-data/partner/itinerary-lov/itinerary-lov.component';
import { MatDialog } from '@angular/material/dialog';
import { LeanConfirmationComponent } from 'src/app/tools/components/lean-confirmation/lean-confirmation.component';

@Component({
    selector: 'ticket-xtrn-list',
    templateUrl: './ticket-xtrn-list.component.html',
    styleUrls: ['./ticket-xtrn-list.component.scss']
})


export class TicketXtrnListComponent extends BasePage2<Ticket> {

    
  @Input() ticketBatch : TicketBatch;

    // Filter fields
    // ---------------------------------------------------
    id                      : number;
    ticketCategory          : TicketCategory;
    ticketType              : TicketType;

    branch                  : Branch;
    partner                 : Partner;
    itinerary               : Itinerary;

    assetBarCode            : string;
    assetProductCategory    : AssetProductCategory;

    priority                : number

    newlyCreated_PL 		    :  boolean = true;
    toBeQualified_PL        :  boolean = true;
    qualified_PL            :  boolean = true;
    scheduled_PL            :  boolean = true;
    processed_PL            :  boolean = true;
    closed_PL               :  boolean = false;



  ticketCategoryLovComponent       = TicketTypeLovComponent;   
  ticketTypeLovComponent           = TicketTypeLovComponent;   
  branchLovComponent               = BranchLovComponent;
  partnerLovComponent              = PartnerLovComponent;
  itineraryLovComponent            = ItineraryLovComponent;
  assetProductCategoryLovComponent = AssetProductCategoryLovComponent

    priorityLov = [
      {name : 'Faible', priority : 1},
      {name : 'Normal', priority : 2},
      {name : 'Haute',  priority : 3}
    ];

    // ---------------------------------------------------


    tickets: Ticket[] = [];
    selectedColumn  = { prop: 'selected',     name: 'S', type : 'boolean' } 


    constructor(
        protected toastr        : ToastrService,
        protected ticketService : TicketService,
        protected router        : Router,
        protected baseService   : BaseService,
        protected userService   : UserService,
        protected leanUtilsService  : LeanUtilsService, 
        protected dialog        : MatDialog,
        protected location      : Location) {
         super(toastr, router, baseService, leanUtilsService, location);

         this.entityName = 'xtrnTicket';
    }



    //----------------------------------------------------------------------
    getRows(): Ticket[] {
        return this.tickets;
    }
    //----------------------------------------------------------------------
    



    //----------------------------------------------------------------------
    loadData() {
      this.ticketService.xtrnTicketsGet().then(tickets => {
              this.tickets = tickets;
      });     
    }
    //----------------------------------------------------------------------


    //----------------------------------------------------------------------
    process(){
      let confirmationMessage = "Confimez-vous bien la création des tickets";

      let dialogRef = this.dialog.open(LeanConfirmationComponent, {autoFocus : false, hasBackdrop : false, data : {title : "Confirmation", confirmationMessage: confirmationMessage}} );
      dialogRef.afterClosed().subscribe(result => {
          if (result) {
            this.ticketService.xtrnTicketsProcess().then(tickets => {
              this.tickets = tickets;
              this.showSuccessFulOperation();
      }); 
          }
      });
    }
    //----------------------------------------------------------------------
  



    //----------------------------------------------------------------------
    fileUpload(files) {
      if (files && files.length > 0) {
          const file: File = files.item(0);
          const reader: FileReader = new FileReader();
          reader.readAsText(file);
          reader.onload = (e) => {
              const stream = reader.result as string; // This variable contains your file as text
              this.ticketService.xtrnTicketsLoad(stream).then(tickets => {
                this.tickets = tickets;
               this.showSuccessFulOperation();
        }); 
          };
      }
    }
    //----------------------------------------------------------------------

}



